export default __webpack_public_path__ + "static/media/mobis-kia.c996620f.png";